var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 21,
    viewBox: "0 0 67 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1335 0L47.6855 20.8123H52.1214L66.6452 0H62.1335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.583 0L56.834 6.13274L54.6161 9.47788L48.0547 0H52.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5637 20.8142L57.8506 14.031L60.0685 10.7788L66.9996 20.8142H62.5637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5103 0H46.3917V20.8123H42.5103V20.0355C41.3884 20.6506 40.102 21 38.7343 21C34.389 21 30.8662 17.4746 30.8662 13.1241C30.8662 8.77354 34.389 5.24814 38.7343 5.24814C40.102 5.24814 41.3903 5.59752 42.5103 6.21266V0ZM38.6918 17.5434C41.1537 17.5434 43.148 15.5456 43.148 13.0832C43.148 10.6208 41.1537 8.62301 38.6918 8.62301C36.2299 8.62301 34.2356 10.6208 34.2356 13.0832C34.2356 15.5456 36.2299 17.5434 38.6918 17.5434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2525 0L16.8193 20.8123H21.3439L35.7623 0H31.2507H31.2525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3479 0L25.8761 6.31858L23.381 9.84956L16.6348 0H21.3479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6441 0H15.5255V20.8123H11.6441V20.0355C10.5222 20.6506 9.23584 21 7.86811 21C3.52281 21 0 17.4746 0 13.1241C0 8.77354 3.52281 5.25 7.86811 5.25C9.23584 5.25 10.5241 5.59938 11.6441 6.21451V0ZM7.8256 17.5434C10.2857 17.5434 12.2818 15.5456 12.2818 13.0832C12.2818 10.6208 10.2875 8.62301 7.8256 8.62301C5.3637 8.62301 3.36941 10.6208 3.36941 13.0832C3.36941 15.5456 5.3637 17.5434 7.8256 17.5434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.8b639d88820bb7cc6476bb3ae331fb4d.svg";
export { ForwardRef as ReactComponent };